import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLoading } from "../../../context/LoadingContext";
import { Card, Container, Button, Form } from "react-bootstrap";
import InputSearch from "../../../components/InputSearhComponent";
import { initializeSetOption } from "../../../utils/InitializeSetDefault";
import { useNavigate, useLocation } from "react-router-dom";
import TableForm2s from "../../../components/TableFormScrb";
import TechExpenseService from "../../../services/techexpenses.service";
import { getQueryString } from "../../../utils/Query";
import { addEditServiceRequest, getServiceRequest } from "../../../commons/ServiceRequest";
import { useAlert } from "../../../context/AlertContext";
import { toFormatISO } from "../../../utils/Time";
import { formatDate } from "../../../commons/FormatValue";
import JobTypeService from "../../../services/jobtype.service";

export default function ExpensesDuringWork() {
  const { loading, setLoading } = useLoading();
  const navigate = useNavigate();
  const { showAlert } = useAlert();
  const { state } = useLocation()

  const [tableData, setTableData] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [SeqNo, setSeqNo] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(15);
  const [allCountData, setAllCountData] = useState();
  const [validated, setValidated] = useState(false);
  const [querySearch, setQuerySearch] = useState(state)

  useEffect(() => {
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: JobTypeService.getJobTypesForTechPlan(),
      callback: (res) => {
        setJobType(res);
      }
    });

    if (state) {
      handleValidated(state, 'submit')
    }
  }, [])

  const searchInput = [
    {
      name: "date",
      label: "วันที่เข้างาน",
      classNames: { label: "mb-3" },
      type: "date",
      size: 3
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 4,
      filterBy: ["seq_no"],
      // value: state && querySearch && state?.seq_no,
      querySearch: querySearch,
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: SeqNo
      }),
      required: true,
      queryService: (query, value) => {
        const q = getQueryString({ seq_no: value, limit: 100, page: 1 })
        getServiceRequest({
          showAlert,
          setLoading: () => { },
          serviceRequest: TechExpenseService.getSeqNo(q),
          callback: (array) => {
            const newArray = array.data?.map(arr => ({
              ...arr,
              seq_no: arr.seq_no
            }))
            setSeqNo(newArray)
          }
        });
      }
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 2,
      noneAsync: true,
      filterBy: ["Job_Type_Name"],
      options: initializeSetOption({
        key: "Id",
        label: "Job_Type_Name",
        dataset: JobType
      }),
      // value: tableData
    },
    {
      name: "no",
      label: "ครั้งที่/งานย่อย",
      classNames: { label: "mb-3" },
      size: 2,
      disabled: true,
      value: tableData[0]?.no,
      type: "text"
    },
    {
      name: "cus_code",
      label: "รหัสลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: 3,
      disabled: true,
      value: tableData[0]?.cus_code,
      type: "text"
    },
    {
      name: "num_branch",
      label: "เลขทีสาขา",
      classNames: { label: "mb-3" },
      size: 2,
      disabled: true,
      value: tableData[0]?.num_branch,
      type: "text"
    },
    {
      name: "cus_name",
      label: "ชื่อสาขา",
      classNames: { label: "mb-3" },
      size: 6,
      disabled: true,
      value: tableData[0]?.cus_name,
      type: "text"
    },
  ];

  const columns = [
    {
      name: "date",
      label: "วันที่บันทึก",
      readOnly: true
    },
    {
      name: "detail",
      label: "รายละเอียดอุปกรณ์/อะไหล่",
      readOnly: true,
    },
    {
      name: "quantity",
      label: "จำนวน",
      readOnly: true,
      width: "80px"
    },
    {
      name: "unit",
      label: "หน่วย",
      readOnly: true,
      width: "80px"
    },
    {
      name: "price",
      label: "ราคา",
      readOnly: true,
      width: "80px"
    },
    {
      name: "total",
      label: "จำนวนเงิน",
      readOnly: true,
    },
    {
      name: "currency",
      label: "สกุลเงิน",
      readOnly: true,
    },
    {
      name: "remark",
      label: "หมายเหตุ",
      readOnly: true,
    },
    {
      label: "",
      type: "activeButton"
    }
  ];

  const handleValidated = (search, type) => {
    if (type == "submit") {
      if (search?.seq_no) {
        setValidated(false)
        getData(search)
      } else {
        setValidated(true)
      }
    } else if (search?.seq_no) {
      setValidated(false)
      setQuerySearch(search)
    } else {
      setTableData([])
      setValidated(false)
      setQuerySearch()
    }
  }
  function getData(search) {
    if (!search?.seq_no) {
      setTableData([])
      return
    }
    setLoading(true)
    const page = search?.page || currentPage
    const limit = search?.limit || rowsPerPage
    const q = {
      // ...querySearch,
      page: page, limit: limit, ...search,
      start: toFormatISO(search.start),
      end: toFormatISO(search?.end)
    }

    setCurrentPage(page)
    setRowsPerPage(limit)
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechExpenseService.getAllTechExpense(getQueryString(q)),
      callback: (res) => { initData(res.data); setAllCountData(res.allCount) }
    });
  }

  function initData(data) {
    const newArray = data.map(el => {
      return {
        Id: el.id,
        date: formatDate(el.expenses_date),
        detail: el.expenses_desc,
        quantity: el.expenses_qty,
        unit: el.expenses_unit,
        price: el.expenses_price,
        total: el.expenses_total_price,
        currency: el.expenses_price_unit,
        remark: el.remark,
        job_actual_date: el.TechnicianPlan.job_actual_date,
        seq_no: el.TechnicianPlan.seq_no,
        // job_type_id: el.TechWorkJobs.TechnicianPlan.job_type_id,
        job_type_name: JobType.find(j => j.Id == el.TechnicianPlan.job_type_id)?.Job_Type_Name,
        // no: ,
        cus_code: el.TechnicianPlan?.SeqInstalljob.InformInstallJobs.Customer.Cus_Code,
        cus_num: el.TechnicianPlan?.SeqInstalljob.InformInstallJobs.Customer.Cus_NumBranch,
        cus_name: el.TechnicianPlan?.SeqInstalljob.InformInstallJobs.Customer.Cus_Name,
      }
    })
    setTableData(newArray)
  }

  async function handleSubmitDelete(e, { Id, seq_no }) {
    addEditServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechExpenseService.deleteTechExpense(Id),
      navigated: (navi) =>
        getData({ seq_no: seq_no })
    });
  }
  return (
    <>
      <Helmet>
        <title>ข้อมูลค่าใช้จ่ายระหว่างทำงาน</title>
        <meta name="description" content="Expenses During Work Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Title className="mb-4 mt-2 fs-2 text-center">
            ข้อมูลค่าใช้จ่ายระหว่างทำงาน
          </Card.Title>
          <Form noValidate validated={validated} >
            <InputSearch
              inputField={searchInput}
              field={searchInput}
              searchCallback={handleValidated}
              fieldClassName={{ inputRow: "justify-content-center", actionButton: "w-auto py-2" }}
            />
          </Form>
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              รายละเอียดค่าใช้จ่ายระหว่างทำงาน
            </Card.Title>

            <Button
              variant="success"
              className="me-2 px-5 py-2 text-dark rounded-pill"
              onClick={() =>
                navigate("add", { state: { JobType } })
              }
            >
              เพิ่มค่าใช้จ่าย
            </Button>
          </Card.Header>

          <Form noValidate className="pb-4" >
            <TableForm2s
              data={tableData}
              columns={columns}
              pending={loading}
              rowsPerPage={rowsPerPage}
              currentPage={currentPage}
              rowCount={allCountData}
              editButton
              deleteButton
              onDeleteCallback={handleSubmitDelete}
            />
          </Form>
        </Card>
      </Container>
    </>
  );
}
